import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'baseline-density-medium', 'BaselineDensityMedium', [["path",{"d":"M4 20h16"}],["path",{"d":"M4 12h16"}],["path",{"d":"M4 4h16"}]]);